import ActionTypes from '@ziynx/action-types';

type GetStatementResponse = Array<
  {
  _id: string,
  data: Array<StatementDataType>
  }>;

type StatementAction = {
  type: string,
  response?: GetStatementResponse,
  error?: any,
}

const initialState = {};

export default function reduceStatement(state = initialState, action: StatementAction) {
  if (!action.type) {
    return state;
  }

  switch (action?.type) {
  case ActionTypes.statements.getAll.START:
    return {
      ...state,
      fetching: true,
      success: false,
      error: null,
      removing: null,
      removalSuccess: null,
      removalError: null,
    };

  case ActionTypes.statements.getAll.SUCCESS:
    return {
      ...state,
      ...(action?.response ?? {}),
      fetching: false,
      success: true,
      error: null,
    };

  case ActionTypes.statements.getAll.ERROR:
    return {
      ...state,
      fetching: false,
      success: false,
      error: action?.error,
    };

  case ActionTypes.statements.patchedQuestion:
    return {
      ...state,
      patchedQuestion: true,
    };

  case ActionTypes.statements.removeQuestion.START:
    return {
      ...state,
      removing: true,
      removalSuccess: false,
      error: null,
    };

  case ActionTypes.statements.removeQuestion.SUCCESS:
    return {
      ...state,
      removing: false,
      removalSuccess: true,
      removalError: null,
    };

  case ActionTypes.statements.removeQuestion.ERROR:
    return {
      ...state,
      removing: false,
      removalSuccess: false,
      removalError: action?.error,
    };
  case ActionTypes.statements.clear:
    return initialState;

  default:
    return state;
  }
}
